import { memo } from 'react';
import Skeleton from 'react-loading-skeleton';
import './style.scss';

interface IProps {
  className?: string;
}

export const SizesSkeleton = (props: IProps): JSX.Element => {
  return <Skeleton className={`sizes ${props.className || ''}`} />;
};

export default memo(SizesSkeleton);
